import { TableCellWithBadge } from "../../../../data-model/tableCells";
import {
  PrimaryGray,
  PrimaryGreen,
  SecondaryYellow,
  TertiaryBlue,
} from "../../../../enums/colors";

export interface AuthTypeBadgeStyle {
  color: string;
  bgColor: string;
}

const AUTH_TYPE_BADGE_COLORS: Record<string, AuthTypeBadgeStyle> = {
  oncology: {
    color: SecondaryYellow.YELLOW_1,
    bgColor: SecondaryYellow.YELLOW_11,
  },
  "primary care": {
    color: TertiaryBlue.BLUE_4,
    bgColor: TertiaryBlue.BLUE_12,
  },
  rheumatology: {
    color: PrimaryGreen.GREEN_1,
    bgColor: PrimaryGreen.GREEN_11,
  },
};

const DEFAULT_AUTH_TYPE_BADGE: AuthTypeBadgeStyle = {
  color: PrimaryGray.GRAY_1,
  bgColor: PrimaryGray.GRAY_16,
};

/**
 * Resolves badge colors for an auth type (specialty) value.
 *
 * @param specialty - Specialty string from the API (e.g. Rheumatology)
 * @returns Foreground and background colors for the tag badge
 */
export const getAuthTypeBadgeColors = (
  specialty: string | undefined,
): AuthTypeBadgeStyle => {
  const key = (specialty ?? "").toLowerCase().trim();
  return AUTH_TYPE_BADGE_COLORS[key] ?? DEFAULT_AUTH_TYPE_BADGE;
};

/**
 * Builds the badge cell payload for the Auth Type table column.
 *
 * @param specialty - Specialty string from the API
 * @returns TableCellWithBadge shape for CustomTable
 */
export const buildAuthTypeBadgeCell = (
  specialty: string | null | undefined,
): TableCellWithBadge => ({
  text: specialty?.trim() || "--",
  ...getAuthTypeBadgeColors(specialty ?? undefined),
});
